<template>
  <v-container fluid>
    <v-container bg fill-height grid-list-md text-xs-center>
      <v-layout row wrap align-center>
        <v-flex>
          <label style="color: orange">
            {{ text1 }}
          </label>

          <v-form ref="form" v-model="valid" :lazy-validation="lazy">
            <v-select
              v-if="signatureType === 'signature' && langu === 'es'"
              prepend-icon="create"
              :items="signatureItems"
              :label="labeltypes"
              @change="signatureSelected"
              :rules="[v => !!v || 'Debes elegir una opción']"
              required
            ></v-select>
            <v-select
              v-if="signatureType === 'signature' && langu === 'en'"
              prepend-icon="create"
              :items="signatureItemsEn"
              :label="labeltypes"
              @change="signatureSelected"
              :rules="[v => !!v || 'Debes elegir una opción']"
              required
            ></v-select>

            <v-text-field
              v-if="langu === 'en'"
              v-model="name"
              :rules="[v => !!v || 'El nombre es obligatorio']"
              :counter="50"
              :label="labelname"
              required
            ></v-text-field>

            <v-text-field
              v-if="langu === 'es'"
              v-model="name"
              :rules="nameRules"
              :counter="50"
              :label="labelname"
              required
            ></v-text-field>

            <v-text-field
              v-if="langu === 'es'"
              v-model="lastname"
              :rules="lastnameRules"
              :counter="50"
              :label="labellastname"
              required
            ></v-text-field>
            <v-text-field
              v-if="langu === 'en'"
              v-model="lastname"
              :rules="[v => !!v || 'El apellido es obligatorio']"
              :counter="50"
              :label="labellastname"
              required
            ></v-text-field>
            <v-text-field
              v-if="langu === 'es'"
              v-model="email"
              :rules="emailRules"
              :label="labelemail"
              required
            ></v-text-field>
            <v-text-field
              v-if="langu === 'en'"
              v-model="email"
              :rules="emailRulesEn"
              :label="labelemail"
              required
            ></v-text-field>

            <v-text-field
              v-if="isSimpleSignature && langu === 'es'"
              v-model="phone"
              :rules="phoneRules"
              :label="labelphone"
              required
            ></v-text-field>

            <v-text-field
              v-if="isSimpleSignature && langu === 'en'"
              v-model="phone"
              :rules="phoneRulesEn"
              :label="labelphone"
              required
            ></v-text-field>

            <v-text-field
              v-if="signatureType === 'video'"
              v-model="nif"
              :rules="documentRules"
              label="Número de DNI"
              
            ></v-text-field>


            <v-layout
              row
              v-if="
                (isAttachDocumentSelected && !isHandWrittenSignature) ||
                  signatureType === 'notification'
              "
            >
              <v-flex>
                <v-text-field
                  :label="labelselect"
                  @click="pickFile"
                  :rules="[
                    v => !!v || 'Es obligatorio que elijas un documento'
                  ]"
                  v-model="documentName"
                  prepend-icon="attach_file"
                  required
                ></v-text-field>
                <input
                  type="file"
                  style="display: none"
                  ref="document"
                  accept="application/pdf"
                  @change="onFilePicked"
                />
              </v-flex>
            </v-layout>
            <v-select
              v-if="isHandWrittenSignature"
              v-model="select"
              :items="items"
              :rules="[v => !!v || 'Es necesario que elijas']"
              label="Item"
              required
            ></v-select>
            <!-- <v-checkbox
      v-model="checkbox"
      :rules="[v => !!v || 'You must agree to continue!']"
      label="Do you agree?"
      required
    ></v-checkbox> -->
            <v-btn @click="clear" color="error">{{ button2text }}</v-btn>

            <v-btn
              :disabled="!valid"
              @click="submit"
              color="orange darken-2"
              class="white--text"
            >
              {{ button1text }}
            </v-btn>
          </v-form>
        </v-flex>
      </v-layout>
    </v-container>
    <v-snackbar
      v-model="isSnackBarVisible"
      :top="true"
      :color="snackBarColor"
      :right="true"
      :timeout="4000"
    >
      {{ snackBarText }}
    </v-snackbar>

    <v-dialog v-model="dialogSuccess" max-width="450">
      <v-card>
        <v-card-title class="headline">{{ dialogtitle }}</v-card-title>

        <v-card-text>
          {{ dialogtext }}
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="orange darken-2" text @click="closeDialog()">
            {{ closetext }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { bodyAut } from "../utils/createLoginAutTokenEmail";
import { bodyAutPlantilla } from "../utils/createLoginAutTokenEmailPlantilla";
import { body } from "../utils/createJSON2Email";
export default {
  props: ["scrollTop"],
  // props: ["scrollTop", "signatureType"],
  // mounted() {
  //   // Google Analytics
  //   this.$ga.page(this.$router);
  // },
  mounted() {
    this.langu = this.$route.query.lang;
    if (this.langu === undefined) {
      this.langu = "es";
    }
    this.$store.commit("setCurrentLang", this.langu);
    if (this.langu == "en") {
      this.text1 =
        "Try to validate the data correctly, since the email field will be used to send you an email indicating the steps to perform the digital signature test and the mobile number for the SMS with OTP (key). Please remember that this digital signature will not have legal validity. ";
      this.labelname = "Name (required)";
      this.labellastname = "Lastname (required)";
      this.labelemail = "E-mail (required)";
      this.labelphone = "Mobile number (required)";
      this.labeltypes = "Types of signature";
      this.labelcheck = " Do you want to sign one of your documents?";
      this.labellselect = "Choose a PDF document";
      this.button1text = "Start Signature Operation";
      this.button2text = "Cancel";
      (this.dialogtext =
        "A signature operation has been created for a person you have indicated. The person will shortly receive an email with a link that will allow them to access the signing process."),
        (this.dialogtitle = "Operation Created");
      this.closetext = "Close";
    } else if (this.langu == "it") {
      this.text1 = "";
    }
  },
  beforeDestroy() {
    document.body.removeAttribute("class", "noscroll");
    window.scrollTo(0, this.scrollTop);
  },
  data: () => ({
    valid: true,
    lazy: false,
    name: "",
    nameRules: [v => !!v || "!", v => (v && v.length <= 50) || "!"],
    lastname: "",
    lastnameRules: [v => !!v || "!", v => (v && v.length <= 50) || "!"],
    email: "",
    emailRules: [
      v => !!v || "E-mail es obligatorio",
      v =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "El E-mail no es válido"
    ],
    emailRulesEn: [
      v => !!v || "E-mail is required",
      v =>
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
          v
        ) || "E-mail is not valid"
    ],
    phone: "",
    phoneRules: [
      v => !!v || "El número de móvil es obligatorio",
      v => /^[0-9\-+]{9,15}$/.test(v) || "El número debe ser válido"
    ],
    phoneRulesEn: [
      v => !!v || "Mobile number is required ",
      v =>
        /^[0-9\-+]{9,15}$/.test(v) ||
        "Must be a valid number with country code and consecutive numbers without space"
    ],
    nif: "",
    documentRules: [
      v => !!v || "!"
      // v => /^[0-9\][A-Z]{9,12}$/.test(v) || "Id. document number must be valid"
    ],
    select: null,
    signatureItems: ["Firma con OTP"], // "Firma con grafo"],
    signatureItemsEn: ["Sign with OTP"], // "Firma con grafo"],
    items: ["Contrato tipo 1", "Contrato tipo 2"],
    checkbox: false,
    isAttachDocumentSelected: false,
    isSimpleSignature: false,
    isHandWrittenSignature: false,
    documentName: "",
    documentUrl: "",
    documentFile: "",
    snackBarColor: "",
    snackBarText: "",
    isSnackBarVisible: false,
    signatureType: "signature",
    dialogSuccess: false,
    langu: "es",
    labelname: "Nombre",
    labellastname: "Apellidos",
    labelemail: "E-mail",
    labelphone: "Número móvil",
    labeltypes: "Tipos de Firma",
    labelseleect: "lige un documento PDF",
    labelcheck: " ¿Quieres firmar uno de tus documentos?",
    button1text: "Iniciar Operación de Firma",
    button2text: "Cancelar",
    wlastname: "Apellidos es obligatorio ",
    title1: "¿Interesado en probar Securyty?",
    text1:
      "Procure validar correctamente los datos, ya que el campo e-mail,  servirá para enviarle un correo electrónico que le indicará los  pasos para realizar la prueba de firma digital y el número de móvil para la recepción del SMS con la OTP (clave) para la firmar.  Recuerde que esta firma digital no tendrá validez legal al tratarse  de una demostración.",
    dialogtext:
      " Se ha creado una operación de firma dirigida a la persona que has indicado. En breve recibirá un email con un enlace que le permitirá acceder al proceso de firma.",
    dialogtitle: "Operación generada",
    closetext: "Cerrar"
  }),
  methods: {
    recaptcha() {
      console.log("recaptcha clicked");
      this.$recaptchaLoaded().then(() => {
        console.log("recaptcha loaded");
        this.$recaptcha("login").then(token => {
          console.log(token); // Will print the token
        });
      });
    },
    signatureSelected(item) {
      if (item === "Firma con OTP" || item === "Sign with OTP") {
        this.isSimpleSignature = true;
        this.isHandWrittenSignature = false;
      } else if (item === "Firma con grafo") {
        this.isHandWrittenSignature = true;
        this.isSimpleSignature = false;
      } else {
        this.isSimpleSignature = true;
        this.isHandWrittenSignature = false;
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        // Native form submission is not yet supported
        // Google Analytics register events
        if (this.signatureType === "signature") {
          this.$ga.event({
            eventCategory: "SimpleSignature", // str
            eventAction: "click", // str
            eventLabel: "CreateButton", // str
            eventValue: 0 // int
          });
        } else if (this.signatureType === "notification") {
          this.$ga.event({
            eventCategory: "CertifiedNotification", // str
            eventAction: "click", // str
            eventLabel: "CreateButton", // str
            eventValue: 0 // int
          });
        }
        axios
          .post(`${process.env.VUE_APP_BASEURL}${"login"}`, {
            username: "jlcl",
            userpassword: "A6xnQhbz4Vx2HuGl4lXwZ5U2I8iziLRFnhP5eNfIRvQ="
          })
          .then(
            success => {
              this.$store.commit("setToken", success.data);
              let bodyData = Object;
              if (this.isSimpleSignature) {
                bodyData = JSON.stringify(bodyAutPlantilla());
                if (this.isAttachDocumentSelected) {
                  bodyData = JSON.stringify(bodyAut());
                } else {
                  bodyData = JSON.stringify(bodyAutPlantilla());
                }
                bodyData = bodyData.replace("##cellphone##", this.phone);
                if (this.langu == "en") {
                  bodyData = bodyData.replace("##idiomavalue##", "en-en");
                  bodyData = bodyData.replace("Telefono", "Cellphon");
                  bodyData = bodyData.replace("Apellidos", "Lastname");
                  bodyData = bodyData.replace("Nombre", "Name");
                  bodyData = bodyData.replace("Correo", "E-mail");
                } else {
                  bodyData = bodyData.replace("##idiomavalue##", "es-es");
                }
              } else if (this.isHandWrittenSignature) {
                bodyData = JSON.stringify(body());
                bodyData = bodyData.replace("##signatureType##", "BIOMETRICA");
                bodyData = bodyData.replace("##resumenif##", "N");
              } else if (this.signatureType === "video") {
                bodyData = JSON.stringify(body());
                bodyData = bodyData.replace(
                  "##signatureType##",
                  "AVANZADA_VIDEO_1PASO"
                );
                bodyData = bodyData.replace("##nif##", this.nif);
                bodyData = bodyData.replace("##resumenif##", "Y");
              }
              bodyData = bodyData.replace("##email##", this.email);
              bodyData = bodyData.replace("##name##", this.name);
              bodyData = bodyData.replace("##lastname##", this.lastname);
              bodyData = JSON.parse(bodyData);
              if (this.isAttachDocumentSelected) {
                bodyData.documents.contrato.documentB64 = this.documentUrl;
              }
              axios
                .post(
                  `${
                    process.env.VUE_APP_BASEURL
                  }${"create/withotpandtoken/2w2w-3e3e3-3e3e3-cdcddcdcd"}`,
                  bodyData
                )
                .then(
                  success => {
                    this.$store.commit(
                      "setESignToken",
                      success.data.loginautToken
                    );
                    this.$store.commit(
                      "setOperationUuid",
                      success.data.uuids[0]
                    );
                    this.$store.commit(
                      "setDocumentUuid",
                      success.data.documentsUuid[0]
                    );
                    this.getOperation();
                  },
                  () => {
                    this.snackBarColor = "error";
                    this.snackBarText =
                      "An error occurred creating the operation. Please, try again";
                    this.isSnackBarVisible = true;
                  }
                );
            },
            () => {
              this.snackBarColor = "error";
              this.snackBarText =
                "An error occurred creating the operation. Please, try again";
              this.isSnackBarVisible = true;
            }
          );
      }
    },
    getOperation() {
      const self = this;
      axios
        .get(
          `${process.env.VUE_APP_BASEURL}${"getoperationbyuuid/"}${
            this.$store.getters.domainUuid
          }${"/"}${this.$store.getters.operationUuid}`
        )
        .then(
          success => {
            this.isLoading = false;
            this.$store.commit("setOperation", success.data);
            success.data.authPolicy.fields.forEach(element => {
              if (element.identifier === "cellphone") {
                this.$store.commit("setCellphone", element.value);
              }
              if (element.identifier === "signbox") {
                this.$store.commit("setSignBoxName", element.value);
              }
            });
            this.$store.commit(
              "setDocumentUuid",
              success.data.documents[0].documentUuid
            );
            if (this.isSimpleSignature) {
              // this.$router.push({ name: "simpleSignature" });
              self.dialogSuccess = true;
            } else if (this.isHandWrittenSignature) {
              this.$router.push({ name: "handwrittenSignature" });
            } else if (this.signatureType === "video") {
              this.$router.push({ name: "identificationSignature" });
            }
          },
          () => {
            this.snackBarColor = "error";
            this.snackBarText =
              "An error occurred getting the operation data. Please try to create another one";
            this.isSnackBarVisible = true;
          }
        );
    },
    clear() {
      this.$refs.form.reset();
    },
    pickFile() {
      this.$refs.document.click();
    },
    onFilePicked(e) {
      const files = e.target.files;
      if (files[0] !== undefined) {
        this.documentName = files[0].name;
        if (this.documentName.lastIndexOf(".") <= 0) {
          return;
        }
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener("load", () => {
          this.documentUrl = fr.result.split(",")[1];
          this.documentFile = files[0]; // this is an image file that can be sent to server...
        });
      } else {
        this.documentName = "";
        this.documentFile = "";
        this.documentUrl = "";
      }
    },
    closeDialog() {
      window.location = "https://www.securyty.com/";
      //this.$router.push({ name: "ContactPage" });
    }
  }
};
</script>
